import axios from '@/libs/api.request';

export const getMemberFundList = data => {
    return axios.request({
        url: 'api/financeManagement/memberFund/getMemberFundList',
        data: data,
        method: 'post'
    });
};

export const getMemberFundRecord = data => {
    return axios.request({
        url: 'api/financeManagement/memberFund/getMemberFundRecord',
        data: data,
        method: 'post'
    });
};

export const saveMemberFundRecord = data => {
    return axios.request({
        url: 'api/financeManagement/memberFund/saveMemberFundRecord',
        data: data,
        method: 'post'
    });
};

export const transferDepositToFund = data => {
    return axios.request({
        url: 'api/financeManagement/memberFund/transferDepositToFund',
        data: data,
        method: 'post'
    });
};

export const depositToBalanceConvert = data => {
    return axios.request({
        url: 'api/financeManagement/memberFund/depositToBalanceConvert',
        data: data,
        method: 'post'
    });
};



export const getDepositBillListByCode = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/getDepositBillListByCode',
        data: data,
        method: 'post'
    });
};

export const getMemberDepositNotPayBackList = data => {
    return axios.request({
        url: 'api/financeManagement/memberFund/getMemberDepositNotPayBackList',
        data: data,
        method: 'post'
    });
};

export const getPreSaleDeposit = data => {
    return axios.request({
        url: 'api/financeManagement/deposit/getPreSaleDeposit',
        data: data,
        method: 'post'
    });
};

